import * as Sentry from '@sentry/react';
import request from './utils/request';

const sentryDsn = import.meta.env.VITE_ADMIN_SENTRY_DSN;

type RuntimeConfigData = {
  adminSentryDsn?: string;
  userSentryDsn?: string;
};

type RuntimeConfigResponse = {
  code?: number;
  msg?: string;
  data?: RuntimeConfigData;
};

let sentryInitialized = false;

const loadRuntimeSentryDsn = async (): Promise<string> => {
  return request
    .get('/grnt/runtime-config', { timeout: 1500 })
    .then((response: RuntimeConfigResponse) => {
      if (response?.code === 0 && response.data?.adminSentryDsn) {
        return response.data.adminSentryDsn;
      }
      return '';
    })
    .catch(() => '');
};

export const initSentry = async () => {
  if (sentryInitialized) {
    return;
  }

  const runtimeSentryDsn = await loadRuntimeSentryDsn();
  const activeSentryDsn = runtimeSentryDsn || sentryDsn;
  if (!activeSentryDsn) {
    return;
  }

  Sentry.init({
    dsn: activeSentryDsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
  sentryInitialized = true;
};
